"use strict";

var bidder = bidder || {};

bidder.ResourceService = function () {
    this.options = {};
};

bidder.ResourceService.prototype = {
    init: function (options) {
        options = options || {};
        var self = this;

        var defaultsOptions = {
            lang: "it"
        };

        $.extend(self.options, defaultsOptions, options);
    },
    load: function () {
        var self = this;
        return $.ajax({
            //url: "/" + self.options.lang + "/resources",
            url: "/api/resources/" + self.options.lang,
            type: "GET",
            dataType: "json"
        });
    }
};